export const INITIALIZE_STEP_PRODUCTS = 'INITIALIZE_STEP_PRODUCTS';
export type INITIALIZE_STEP_PRODUCTS = typeof INITIALIZE_STEP_PRODUCTS;

export const INITIALIZE_STEP_PRODUCTS_SUCCESS =
  'INITIALIZE_STEP_PRODUCTS_SUCCESS';
export type INITIALIZE_STEP_PRODUCTS_SUCCESS = typeof INITIALIZE_STEP_PRODUCTS_SUCCESS;

export const INITIALIZE_STEP_PRODUCTS_FAILED =
  'INITIALIZE_STEP_PRODUCTS_FAILED';
export type INITIALIZE_STEP_PRODUCTS_FAILED = typeof INITIALIZE_STEP_PRODUCTS_FAILED;

export const DESTROY_STEP_PRODUCTS = 'DESTROY_STEP_PRODUCTS';
export type DESTROY_STEP_PRODUCTS = typeof DESTROY_STEP_PRODUCTS;

export const ADD_PRODUCT_NODE = 'ADD_PRODUCT_NODE';
export type ADD_PRODUCT_NODE = typeof ADD_PRODUCT_NODE;

export const DELETE_PRODUCT_NODE = 'DELETE_PRODUCT_NODE';
export type DELETE_PRODUCT_NODE = typeof DELETE_PRODUCT_NODE;

export const ADD_COLLECTOR_GROUP_DISPLAY_METADATA = 'ADD_COLLECTOR_GROUP_DISPLAY_METADATA';
export type ADD_COLLECTOR_GROUP_DISPLAY_METADATA = typeof ADD_COLLECTOR_GROUP_DISPLAY_METADATA;